import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { set_selected_group_action } from "../actions";
import {
  profileSelector,
  groupsSelector,
  selectedGroupSelector,
} from "../selectors";
import { get_groups } from "../api";
import useCart from "../../cart/hooks/useCart";
import { showMessage } from "react-native-flash-message";
import { useToast } from "digiwash-components";

function crossPlatformLogoImport() {
  let asset = require(`../../../resources/profile-picture.png`);
  return asset?.default || asset;
}

let logo = crossPlatformLogoImport();

function makeWorkspaces(profile, groups) {
  if (!profile) {
    return null;
  }

  let workspaces = [];
  if (profile) {
    workspaces.push({
      id: "personal",
      name: `${profile.first_name} ${profile.last_name}`,
      logo,
    });
  }
  if (groups) {
    if (Array.isArray(groups)) {
      for (let group of groups) {
        workspaces.push({
          id: group.id,
          logo,
          name: group.name,
          agreement: group.agreement,
        });
      }
    }
  }

  return workspaces;
}

function detectActiveWorkspace(workspaces, selected) {
  if (!workspaces) {
    return null;
  }

  if (!selected) {
    return workspaces[workspaces.length - 1];
  }

  return (
    workspaces.find((workspace) => workspace.id === selected) || workspaces[0]
  );
}

function useWorkspaces() {
  let { revalidateCart, coupon } = useCart();
  let [changeActiveWorkspaceIsLoading, setChangeActiveWorkspaceIsLoading] =
    useState(false);
  let dispatch = useDispatch();
  let groups = useSelector(groupsSelector);
  let selectedGroup = useSelector(selectedGroupSelector);
  let profile = useSelector(profileSelector);
  let toast = useToast();

  function changeActiveWorkspace(groupId) {
    setChangeActiveWorkspaceIsLoading(true);
    let nextWorkspace = detectActiveWorkspace(workspaces, groupId);

    let nextCoupon = nextWorkspace?.agreement?.promotion_code;
    if (nextCoupon) {
      if (!coupon.code) {
        coupon
          .add(nextCoupon)
          .then(() => {
            toast.show("کد تخفیف با موفقیت افزوده شد.", {
              data: { type: "success" },
            });
          })
          .catch((error) => {
            showMessage({
              message: error,
              type: "danger",
            });
          })
          .finally(() => {
            revalidateCart().finally(() => {
              setChangeActiveWorkspaceIsLoading(false);
            });
          });
      } else {
        coupon.remove().finally(() => {
          return coupon
            .add(nextCoupon)
            .catch((error) => {
              showMessage({
                message: error,
                type: "danger",
              });
            })
            .finally(() => {
              revalidateCart();
              setChangeActiveWorkspaceIsLoading(false);
            });
        });
      }
    } else {
      if (coupon.code) {
        coupon.remove().finally(() => {
          revalidateCart().finally(() => {
            setChangeActiveWorkspaceIsLoading(false);
          });
        });
      } else {
        setChangeActiveWorkspaceIsLoading(false);
      }
    }
    dispatch(set_selected_group_action(groupId));
  }

  let workspaces = makeWorkspaces(profile, groups);

  return {
    refetch: get_groups,
    list: workspaces,
    activeWorkspace: detectActiveWorkspace(workspaces, selectedGroup),
    changeActiveWorkspace,
    changeActiveWorkspaceIsLoading,
  };
}

export default useWorkspaces;
